import { render, staticRenderFns } from "./comp-panjar-table.vue?vue&type=template&id=2bccbd91&scoped=true&"
import script from "./comp-panjar-table.vue?vue&type=script&lang=js&"
export * from "./comp-panjar-table.vue?vue&type=script&lang=js&"
import style0 from "./comp-panjar-table.vue?vue&type=style&index=0&id=2bccbd91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bccbd91",
  null
  
)

export default component.exports